export const LAMINATE_REGEX = /^Laminate/i;
export const WOOD_REGEX = /^(Wood|Butcher Block)$/i;
